import React, { useEffect, useState } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {ClienteF} from '../../../../../interfaces/facturacion.interface'
import {State} from '../../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionFacturacionCliente} from '../../../../../actions/action-creators'
import { isNullOrEmpty } from '../../../../../utils/strings.utils'
import InputPhone from '../../../../../components/Inputs/InputPhone'
import SearchSelect from '../../../../../components/Inputs/SearchSelect'

const FormDocV1 = () => {
  const formCliente: ClienteF = useSelector((state: State) => state.facturacion.formCliente)
  const errors: ClienteF = useSelector((state: State) => state.facturacion.errorsFormCliente)
  const {tipoDocumento, departamentos, municipios, actividadesEconomicas} = useSelector(
    (state: State) => state.catalogos
  )
  const [catalogueActividadEconomica, setCatalogueActividadEconomica] = useState(
    actividadesEconomicas.map((tipo) => {
        return ({
          ...tipo,
          codigo_nombre: `${tipo.codigo} - ${tipo.valor}`
        })
    })
  )
  const loader = useSelector((state: State) => state.general.loader)
  const dispatch = useDispatch()

  const acciones = bindActionCreators(actionFacturacionCliente, dispatch)

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec6-0b1e6fa6' className='w-layout-cell'>
      <div className='card w-form'>
        <form
          className='form-content'
          data-wf-page-id='64b58c72be2b65200b1e6fa6'
          data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc'
          
        >
          <div>
            <h3 className='card-title l'>Datos del Cliente</h3>
          </div>
          <div className='form-separator'></div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='fecha' className='field-label m'>
                Fecha de factura
              </label>
              <input autoComplete='off'
                type='date'
                className='m text-field w-input'
                name='fecha'
                data-name=''
                id='fecha'
                min='2000-01-01'
                value={formCliente.fecha}
                disabled={true}
                onChange={(e) => {acciones.facturacionFormClienteHandleChangeInput(e); acciones.facturacionFormClienteOnBlur(e)}}
              />
              {errors.fecha && <p className='alert s'>{errors.fecha}</p>}
            </div>
            {/* <div className='label-input'>
              <label htmlFor='tipoDocumento' className='field-label m'>
                Tipo de documento
              <span style={{color: 'red'}}>*</span>
              </label>
              <SearchSelect data={[...tipoDocumento.filter(tp => tp.codigo === "36")]} disabled = {false} keyNameText='valor' keyNameValue='codigo' placeholder='Tipo de documento de identificación' value={formCliente.tipoDocumento} name='tipoDocumento' onChange={(value: any) => {acciones.facturacionFormClienteHandleChangeInput({target: {value: value?.value, name: 'tipoDocumento'}}); acciones.facturacionFormClienteOnBlur({target: {value: value?.value, name: 'tipoDocumento'}})}}/>
              {errors.tipoDocumento && <p className='alert s'>{errors.tipoDocumento}</p>}
            </div> */}
          <div className='label-input'>
            <div style={{display: formCliente.tipoDocumento === '-1' ? 'none' : ''}} className='label-input'>
              <label htmlFor='numId' className='field-label m'>
                {formCliente.nombreTipoDocumento || 'No. Identificación'}
              <span style={{color: 'red', display: formCliente.tipoDocumento === '36' ? '' : 'none'}}>*</span>            
              </label>
              <div style={{maxWidth: 380, fontSize: 11}} className='alert-info-text'>
                Ingresa el número de identificación sin guiones.
              </div>
              <input autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='numId'
                data-name='numId'
                placeholder={`${formCliente.nombreTipoDocumento || 'Identificación'}`}
                id='numId'
                disabled={formCliente.tipoDocumento ? false : true}
                maxLength={20}
                value={formCliente.numId}
                onChange={(e) => {acciones.facturacionFormClienteHandleChangeInput(e); acciones.facturacionFormClienteOnBlur(e)}}
              />
              {errors.numId && <p className='alert s'>{errors.numId}</p>}
            </div>
            <div className='label-input'>
            </div>
          </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='nombre' className='field-label m'>
                Nombre del Cliente
              <span style={{color: 'red', display: formCliente.tipoDocumento === '36' ? '' : 'none'}}>*</span>            
              </label>
              <input autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='nombre'
                data-name=''
                placeholder='Nombre del cliente'
                id='nombre'
                disabled={formCliente.tipoDocumento ? false : true}
                maxLength={250}
                value={formCliente.nombre}
                onChange={(e) => {acciones.facturacionFormClienteHandleChangeInput(e); acciones.facturacionFormClienteOnBlur(e)}}
              />
              {errors.nombre && <p className='alert s'>{errors.nombre}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='departamento' className='field-label m'>
                Departamento
              <span style={{color: 'red', display: formCliente.tipoDocumento === '36' ? '' : 'none'}}>*</span>            
              </label>
              {/* <select
                id='departamento'
                name='departamento'
                data-name=''
                className='m text-field w-select'
                disabled={loader ? true : formCliente.tipoDocumento ? false : true}
                value={formCliente.departamento}
                onChange={acciones.facturacionFormClienteHandleChangeInput}
                onBlur={acciones.facturacionFormClienteOnBlur}
              >
                <option value=''>SELECCIONA UNA OPCIÓN</option>
                {departamentos.map((tipo) => (
                  <option value={tipo?.codigo} key={tipo?.codigo}>
                    {tipo?.valor?.toUpperCase()}
                  </option>
                ))}
              </select> */}
              <SearchSelect defaultValue={null} disabled = {loader ? true : formCliente.tipoDocumento ? false : true} placeholder='Departamento' value={formCliente.departamento} keyNameText='valor' keyNameValue='codigo' data={departamentos} name='departamento' onChange={(value: any) => {acciones.facturacionFormClienteHandleChangeInput({target: {value: value?.value, name: 'departamento'}}) ; acciones.facturacionFormClienteOnBlur({target: {value: value?.value, name: 'departamento'}})}}/>
              {errors.departamento && <p className='alert s'>{errors.departamento}</p>}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='municipio' className='field-label m'>
                Municipio
              <span style={{color: 'red', display: formCliente.tipoDocumento === '36' ? '' : 'none'}}>*</span>            
              </label>
              {/* <select
                name='municipio'
                data-name=''
                id='municipio'
                className='m text-field w-select'
                disabled={isNullOrEmpty(formCliente.departamento) ? true : formCliente.tipoDocumento ? false : true}
                value={formCliente.municipio}
                onChange={acciones.facturacionFormClienteHandleChangeInput}
                onBlur={acciones.facturacionFormClienteOnBlur}
              >
                <option value=''>SELECCIONA UNA OPCIÓN</option>
                {municipios.map((tipo) => (
                  <option value={tipo?.codigo} key={tipo?.codigo}>
                    {tipo?.valor?.toUpperCase()}
                  </option>
                ))}
              </select> */}
              <SearchSelect disabled = {isNullOrEmpty(formCliente.departamento) ? true : formCliente.tipoDocumento ? false : true} defaultValue={null} placeholder='Municipio' value={formCliente.municipio} keyNameText='valor' keyNameValue='codigo' data={municipios} name='municipio' onChange={(value: any) => {acciones.facturacionFormClienteHandleChangeInput({target: {value: value?.value, name: 'municipio'}}) ; acciones.facturacionFormClienteOnBlur({target: {value: value?.value, name: 'municipio'}})}}/>

              {errors.municipio && <p className='alert s'>{errors.municipio}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='direccion' className='field-label m'>
                Dirección
              <span style={{color: 'red', display: formCliente.tipoDocumento === '36' ? '' : 'none'}}>*</span>            
              </label>
              <input autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='direccion'
                data-name=''
                placeholder='Dirección'
                id='direccion'
                disabled={isNullOrEmpty(formCliente.municipio) ? true : formCliente.tipoDocumento ? false : true}
                maxLength={200}
                value={formCliente.direccion}
                onChange={(e) => {acciones.facturacionFormClienteHandleChangeInput(e); acciones.facturacionFormClienteOnBlur(e)}}
              />
              {errors.direccion && <p className='alert s'>{errors.direccion}</p>}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='email' className='field-label m'>
                Correo electrónico
              <span style={{color: 'red', display: formCliente.tipoDocumento === '36' ? '' : 'none'}}>*</span>            
              </label>
              <input autoComplete='off'
                type='email'
                className='m text-field w-input'
                name='email'
                data-name='Correo electrónico'
                placeholder='Correo electrónico'
                id='email'
                disabled={formCliente.tipoDocumento ? false : true}
                value={formCliente.email}
                onChange={(e) => {acciones.facturacionFormClienteHandleChangeInput(e); acciones.facturacionFormClienteOnBlur(e)}}
              />
              {errors.email && <p className='alert s'>{errors.email}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='telefono' className='field-label m'>
                Teléfono celular
              <span style={{color: 'red', display: formCliente.tipoDocumento === '36' ? '' : 'none'}}>*</span>            
              </label>
              <InputPhone
                className='m text-field w-input'
                name='telefono'
                value={formCliente.telefono}
                onChange={acciones.facturacionFormClienteHandleChangeInputPhone}
                onBlur={acciones.facturacionFormClienteOnBlur}
                disabled={formCliente.tipoDocumento ? false : true}
              />
              {/* <input autoComplete='off'
                type='tel'
                data-name='telefono'
                placeholder='(+503) 2341 4324'
                id='telefono'
                maxLength={30}
              /> */}
              {errors.telefono && <p className='alert s'>{errors.telefono}</p>}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='actividad' className='field-label m'>
                Actividad
              <span style={{color: 'red', display: formCliente.tipoDocumento === '36' ? '' : 'none'}}>*</span>            
              </label>
              {/* <select
                id='actividad'
                name='actividad'
                data-name='actividad'
                className='m text-field w-select'
                disabled={formCliente.tipoDocumento ? false : true}
                value={formCliente.actividad}
                onChange={acciones.facturacionFormClienteHandleChangeInput}
                onBlur={acciones.facturacionFormClienteOnBlur}
                style={{textTransform: 'uppercase'}}
              >
                <option value=''>Selecciona una opción</option>
                {actividadesEconomicas.map((tipo) =>
                  tipo?.codigo?.trim() !== '' ? (
                    <option value={tipo?.codigo} key={tipo?.codigo}>
                      {tipo?.codigo} - {tipo?.valor}
                    </option>
                  ) : null
                )}
              </select> */}
              <SearchSelect defaultValue={null} disabled={formCliente.tipoDocumento ? false : true} value={formCliente.actividad} name='actividad' data={catalogueActividadEconomica} keyNameText='codigo_nombre' keyNameValue='codigo' placeholder='Actividad económica' onChange={(value: any) => {acciones.facturacionFormClienteHandleChangeInput({target: {value: value?.value, name: 'actividad'}}); acciones.facturacionFormClienteOnBlur({target: {name: 'actividad', value: value?.value}})}}/>
              {errors.actividad && <p className='alert s'>{errors.actividad}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='nrc' className='field-label m'>
                NRC
              <span style={{color: 'red', display: formCliente.tipoDocumento === '36' ? '' : 'none'}}>*</span>            
              </label>
              <input autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='nrc'
                data-name='nrc'
                placeholder='NRC'
                id='nrc'
                disabled={formCliente.tipoDocumento ? false : true}
                value={formCliente.nrc}
                onChange={(e) => {acciones.facturacionFormClienteHandleChangeInput(e); acciones.facturacionFormClienteOnBlur(e)}}
              />
              {errors.nrc && <p className='alert s'>{errors.nrc}</p>}
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default FormDocV1
